"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVariablesWithRange = exports.extractVariableNameFromRange = exports.createRangeVariable = exports.isRangeVariable = exports.RANGE_SUFFIX = void 0;
const common_1 = require("@finley-technologies/common");
exports.RANGE_SUFFIX = '_RANGE';
const isRangeVariable = (variableName) => {
    return variableName.endsWith(exports.RANGE_SUFFIX);
};
exports.isRangeVariable = isRangeVariable;
const createRangeVariable = (variableName) => {
    return `${variableName}${exports.RANGE_SUFFIX}`;
};
exports.createRangeVariable = createRangeVariable;
const extractVariableNameFromRange = (rangedHeader) => {
    (0, common_1.finleyAssert)((0, exports.isRangeVariable)(rangedHeader), `"${rangedHeader}" is not a ranged variable`);
    return rangedHeader.slice(0, -exports.RANGE_SUFFIX.length);
};
exports.extractVariableNameFromRange = extractVariableNameFromRange;
const createVariablesWithRange = (variableNames) => {
    const variableWithRangeNames = variableNames.reduce((allNames, variable) => {
        allNames.push(variable);
        allNames.push((0, exports.createRangeVariable)(variable));
        return allNames;
    }, []);
    return variableWithRangeNames;
};
exports.createVariablesWithRange = createVariablesWithRange;
//# sourceMappingURL=rangeVariables.js.map